import { useForm } from "react-hook-form";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, addDoc, Timestamp, doc, updateDoc, getDoc, arrayUnion } from "firebase/firestore";
import { storage, db } from '../Firebase/Firebase';
import { useState, useEffect } from "react";
import './crearMarca.css';
import { useNavigate } from "react-router-dom";

import Navbar from '../Components/NavBarAirbnbStyle';
import NavbarMobileVersion from "../Components/NavBar/NavBarMobileVersion";
export default function CrearMarca() {
  const { register, handleSubmit, reset } = useForm();
  const [mensaje, setMensaje] = useState("");
  const [logoFile, setLogoFile] = useState(null);
  const auth = getAuth();
  const usuarioActual = auth.currentUser;
  const uid = usuarioActual?.uid;
  const [redesSociales, setRedesSociales] = useState({
    Facebook: "",
    Instagram: "",
    LinkedIn: "",
    TwitterX: "",
    Whatsapp: "",
    YouTube: "",
    TikTok: ""
  });

  const handleRedChange = (red, value) => {
    setRedesSociales(prev => ({ ...prev, [red]: value }));
  };
  const actualizarUsuario = async (marcaId) => {
    const auth = getAuth();
    const usuario = auth.currentUser;

    if (!usuario) {
      console.error("No hay usuario autenticado");
      return;
    }

    const uid = usuario.uid;
    const usuarioRef = doc(db, "usuarios", uid);

    try {
      await updateDoc(usuarioRef, {
        marcas: arrayUnion(marcaId) // esto acumula en un arreglo sin duplicar
      });
      console.log("Marca ID agregada al usuario");
    } catch (error) {
      console.error("Error al actualizar el usuario:", error);
    }
  };

  const uploadLogo = async () => {
    if (!logoFile) return null;
    const logoRef = ref(storage, `logos/${Date.now()}_${logoFile.name}`);
    const snapshot = await uploadBytes(logoRef, logoFile);
    return await getDownloadURL(snapshot.ref);
  };

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      const logoUrl = await uploadLogo();
      const redesFiltradas = Object.entries(redesSociales)
        .filter(([_, url]) => url.trim() !== "")
        .map(([nombre, url]) => `${nombre}: ${url}`);

      const marca = {
        Activo: true,
        correo: data.correo,
        descripcion: data.descripcion,
        fechaRegistro: Timestamp.now(),
        logo: logoUrl,
        nombre: data.nombre,
        redes: redesFiltradas,
        telefono: data.telefono,
      };

      // 👉 Guardamos la marca y obtenemos su ID
      const docRef = await addDoc(collection(db, "marca"), marca);
      const marcaId = docRef.id;

      // 👉 Actualizamos el usuario con el ID de la marca
      await actualizarUsuario(marcaId);

      // 👉 Mensaje y redirección
      setMensaje("Marca creada con éxito");
      reset();
      setRedesSociales({
        Facebook: "", Instagram: "", LinkedIn: "", TwitterX: "",
        Whatsapp: "", YouTube: "", TikTok: ""
      });

      // Espera un poco y redirige
      setTimeout(() => {
        navigate("/space"); // cambia esto a tu ruta deseada
      }, 1000);

    } catch (error) {
      console.error("Error al guardar la marca:", error);
      setMensaje("Error al crear la marca");
    }
  };
   const [isDarkMode, setIsDarkMode] = useState(() => {
      try {
        // Intentamos leer valor guardado en localStorage
        const saved = localStorage.getItem('darkMode');
        if (saved !== null) {
          const parsed = JSON.parse(saved);
          if (typeof parsed === 'boolean') return parsed; // Solo si es booleano válido
        }
      } catch (error) {
        // Si JSON.parse falla o localStorage no está disponible, ignoramos el error
        console.warn('Error leyendo localStorage darkMode:', error);
      }
  
      // Detectar modo oscuro sistema solo si está disponible window.matchMedia
      const prefersDark = typeof window !== 'undefined' && window.matchMedia
        ? window.matchMedia('(prefers-color-scheme: dark)').matches
        : false;
  
      // Detectar hora nocturna (7pm a 6am)
      const hour = new Date().getHours();
      const isNight = hour >= 19 || hour < 6;
  
      // Retorna true o false seguro
      return prefersDark || isNight;
    });
  
    // Cargar el tema al inicio (localStorage, sistema u hora)
    useEffect(() => {
      const savedTheme = localStorage.getItem('darkMode');
      if (savedTheme !== null) {
        setIsDarkMode(JSON.parse(savedTheme));
      } else {
        // Detecta modo oscuro sistema
        const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  
        // Detecta modo oscuro por hora (7pm - 6am)
        const hour = new Date().getHours();
        const isNight = hour >= 19 || hour < 6;
  
        setIsDarkMode(prefersDark || isNight);
      }
    }, []);
  
    // Guardar la preferencia y aplicar clase al body
    useEffect(() => {
      localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
      document.body.classList.toggle('dark-mode', isDarkMode);
    }, [isDarkMode]);
  
    // Función para cambiar el modo
    const toggleDarkMode = () => setIsDarkMode(!isDarkMode);
  
  return (
    <>
      <Navbar isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <NavbarMobileVersion isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
      <div className="crear-marca-container">
        <h2 className="title">Registra tu Marca</h2>
        {mensaje && <p className="mensaje">{mensaje}</p>}
        <form onSubmit={handleSubmit(onSubmit)} className="form">
          <div className="form-grid">
            <div className="form-field">
              <input type="text" {...register("nombre")} required />
              <label>Nombre</label>
            </div>
            <div className="form-field">
              <input type="email" {...register("correo")} required />
              <label>Correo</label>
            </div>
            <div className="form-field">
              <input type="text" {...register("telefono")} required />
              <label>Teléfono</label>
            </div>
            <div className="form-field">
              <input type="file" accept="image/*" onChange={(e) => setLogoFile(e.target.files[0])} required />
              <label>Logo</label>
            </div>
            <div className="form-field full">
              <textarea rows="4" {...register("descripcion")} required />
              <label>Descripción</label>
            </div>
          </div>

          <div className="form-grid">
            {Object.entries(redesSociales).map(([red, url]) => (
              <div key={red} className="form-field">
                <input
                  type="url"
                  value={url}
                  onChange={(e) => handleRedChange(red, e.target.value)}
                  placeholder=""
                />
                <label>{red}</label>
              </div>
            ))}
          </div>

          <button type="submit" className="submit-button">
            Crear Marca
          </button>
        </form>
      </div></>
  );
}
